import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap';
import './Dialog.scss';

export default class Dialog extends Component {
    constructor(props) {
        super(props);

        this.handleShow = this
            .handleShow
            .bind(this);

        this.handleClose = this
            .handleClose
            .bind(this);

        this.handleCancel = this
            .handleCancel
            .bind(this);

        this.state = {
            show: true
        }
    }

    handleClose() {
        if (this.props.onClose) {
            this
                .props
                .onClose();
        }

        this.setState({ show: false });

    }

    handleCancel() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
        this.setState({ show: false });
    }




    handleShow() {
        this.setState({ show: true });
    }

    render() {
        const showCloseButton = this.props.closeButton
            ? this.props.closeButton === 'true'
            : true;

        const cancelButtonText = this.props.cancelButtonText
            ? this.props.cancelButtonText
            : 'Cancel';

        const closeButtonText = this.props.closeButtonText
            ? this.props.closeButtonText
            : 'Close';

        const msg = this.props.message
            ? <p>{this.props.message}</p>
            : null;
        const children = this.props.children
            ? this.props.children
            : null;

        return (
            <div className={this.props.customClass ? this.props.customClass : "modal-dialog"}>
                <Modal
                    show={this.state.show || this.props.showAlways}
                    onHide={this.handleCancel}
                    keyboard={false}
                    backdrop="static">

                    <Modal.Header closeButton={showCloseButton}>
                        <Modal.Title>
                            {this.props.title}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        {children}
                        {msg}
                    </Modal.Body>

                    {this.props.hideFooter ? null :
                        <Modal.Footer>
                            {this.props.showCancelButton === true ?
                                <Button bsStyle="basic"

                                    onMouseEnter={this.props.onMouseEnter}
                                    onMouseLeave={this.props.onMouseLeave}

                                    onClick={this.handleCancel}>
                                    {cancelButtonText}</Button>
                                : ''}
                            {this.props.hideOkButton ? null: this.props.allowDisable === true ?
                                <Button bsStyle="primary" className="btn-wide" disabled={this.props.isDisabled} onClick={this.handleClose}>{closeButtonText}</Button>
                                : <Button bsStyle="primary" className="btn-wide" onClick={this.handleClose}>{closeButtonText}</Button>
                            }

                        </Modal.Footer>}

                </Modal>

            </div>
        )
    }
}
